import React, { Component } from 'react';
import Link from 'gatsby-link'
import classNames from "classnames";
import { translate } from "react-i18next";
import styled from 'styled-components'

const LanguageWrapper = styled.div`
  padding-right: 1rem;
  margin-right: 1rem;
  border-right: 1px solid rgba(0,0,0,.25);

  &.white {
    border-right: 1px solid rgba(255,255,255,.25);
  }

`

const LanguageLink = styled(Link)`
  margin-right: .5rem;
  text-decoration: none;
  text-transform: uppercase;
  font-size: .875rem;
  color: #303030;

  &:last-child {
    margin: 0;
  }

  &.active {
    font-weight: bold;
  }

  &.white {
    color: #fff;
  }

`

class LanguageSwitcher extends Component {
  constructor(props) {
    super(props);
    const { i18n } = this.props;
    this.state = { language: i18n.language };

    this.handleChangeLanguage = this.handleChangeLanguage.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ language: nextProps.i18n.language });
  }

  handleChangeLanguage(lng) {
    const { i18n } = this.props;
    i18n.changeLanguage(lng);
  }

  renderLanguageChoice({ code, label }, linkColor) {
    const buttonClass = classNames(linkColor, {
      "active": this.state.language === code,
    });

    let languageUrl = '/'

    if (code != 'fi')
      languageUrl = code

    return (
      <LanguageLink
        to={languageUrl}
        key={code}
        className={buttonClass}
        onClick={() => this.handleChangeLanguage(code)}
      >
        {code}
      </LanguageLink>
    );
  }

  render() {
    const languages = [
      { code: "fi", label: "Suomi" },
      { code: "sv", label: "Svenska" },
      { code: "en", label: "English" },
    ];

    return (
      <LanguageWrapper className={this.props.linkColor}>
        {languages.map(language => this.renderLanguageChoice(language, this.props.linkColor))}
      </LanguageWrapper>
    );
  }
}

export default translate("LanguageSwitcher")(LanguageSwitcher);



// WEBPACK FOOTER //
// ./src/components/languageSwitcher.js